import { createSlice } from "@reduxjs/toolkit";

const salesSlice = createSlice({
  name: "sales",
  initialState: {
    Sales: null,
  },
  reducers: {
    salesSuccess: (state, action) => {
      state.Sales = action.payload;
    },
    clearSales: (state) => {
      state.Sales = null;
    },
  },
});

export const { salesSuccess, clearSales } = salesSlice.actions;
export default salesSlice.reducer;
